import { createContext, useContext, useEffect, useState } from "react";

export const THEMES = {
  nebula: {
    id: "nebula", name: "Nebula", preview: "#13142A",
    vars: {
      "--cresc-bg":         "#0F1020",
      "--cresc-surface":    "#16172A",
      "--cresc-surface-2":  "#1E2040",
      "--cresc-surface-3":  "#252748",
      "--cresc-border":     "#2E3060",
      "--cresc-border-sub": "#1E2040",
      "--cresc-text":       "#FFFFFF",
      "--cresc-text-2":     "#8B8FA8",
      "--cresc-text-3":     "#5A5D78",
      "--cresc-text-4":     "#3A3D55",
      "--cresc-accent":     "#7C6CF8",
      "--cresc-accent-2":   "#6B5CE7",
    },
  },
  system: {
    id: "system", name: "System", preview: "#0E0E10",
    vars: {
      "--cresc-bg":         "#0E0E10",
      "--cresc-surface":    "#141416",
      "--cresc-surface-2":  "#1C1C1F",
      "--cresc-surface-3":  "#222226",
      "--cresc-border":     "#2A2A2E",
      "--cresc-border-sub": "#1E1E22",
      "--cresc-text":       "#F0F0F0",
      "--cresc-text-2":     "#888892",
      "--cresc-text-3":     "#56565E",
      "--cresc-text-4":     "#36363C",
      "--cresc-accent":     "#F0F0F0",
      "--cresc-accent-2":   "#D0D0D0",
    },
  },
  obsidian: {
    id: "obsidian", name: "Obsidian", preview: "#0A0A0A",
    vars: {
      "--cresc-bg":         "#0A0A0A",
      "--cresc-surface":    "#111111",
      "--cresc-surface-2":  "#141414",
      "--cresc-surface-3":  "#1A1A1A",
      "--cresc-border":     "#2A2A2A",
      "--cresc-border-sub": "#1E1E1E",
      "--cresc-text":       "#EDEDED",
      "--cresc-text-2":     "#A1A1AA",
      "--cresc-text-3":     "#71717A",
      "--cresc-text-4":     "#52525B",
      "--cresc-accent":     "#E8E8E8",
      "--cresc-accent-2":   "#C0C0C0",
    },
  },
  midnight: {
    id: "midnight", name: "Midnight", preview: "#070C18",
    vars: {
      "--cresc-bg":         "#070C18",
      "--cresc-surface":    "#0D1627",
      "--cresc-surface-2":  "#111E33",
      "--cresc-surface-3":  "#172540",
      "--cresc-border":     "#1E3555",
      "--cresc-border-sub": "#152A46",
      "--cresc-text":       "#E8F0FE",
      "--cresc-text-2":     "#8FADD6",
      "--cresc-text-3":     "#5A7BA8",
      "--cresc-text-4":     "#3D5A7E",
      "--cresc-accent":     "#A8C4F0",
      "--cresc-accent-2":   "#7AA0E8",
    },
  },
  dusk: {
    id: "dusk", name: "Dusk", preview: "#0D0813",
    vars: {
      "--cresc-bg":         "#0D0813",
      "--cresc-surface":    "#160F20",
      "--cresc-surface-2":  "#1C1329",
      "--cresc-surface-3":  "#231830",
      "--cresc-border":     "#3B2657",
      "--cresc-border-sub": "#2A1A42",
      "--cresc-text":       "#F0EAFF",
      "--cresc-text-2":     "#B09CCE",
      "--cresc-text-3":     "#7A6A99",
      "--cresc-text-4":     "#5A4E75",
      "--cresc-accent":     "#C8B8F0",
      "--cresc-accent-2":   "#A890E0",
    },
  },
  mocha: {
    id: "mocha", name: "Mocha", preview: "#120D09",
    vars: {
      "--cresc-bg":         "#120D09",
      "--cresc-surface":    "#1C1410",
      "--cresc-surface-2":  "#241A14",
      "--cresc-surface-3":  "#2E221A",
      "--cresc-border":     "#3D2E24",
      "--cresc-border-sub": "#2E2018",
      "--cresc-text":       "#F2E8DC",
      "--cresc-text-2":     "#C4A882",
      "--cresc-text-3":     "#8C7258",
      "--cresc-text-4":     "#5E4E3C",
      "--cresc-accent":     "#E8D0A8",
      "--cresc-accent-2":   "#D0B080",
    },
  },
};

function buildThemeCSS(vars) {
  const bg  = vars["--cresc-bg"];
  const s1  = vars["--cresc-surface"];
  const s2  = vars["--cresc-surface-2"];
  const s3  = vars["--cresc-surface-3"];
  const b1  = vars["--cresc-border"];
  const b2  = vars["--cresc-border-sub"];
  const t1  = vars["--cresc-text"];
  const t2  = vars["--cresc-text-2"];
  const t3  = vars["--cresc-text-3"];
  const t4  = vars["--cresc-text-4"];
  const acc = vars["--cresc-accent"];

  return `
    body, #root { background-color: ${bg} !important; color: ${t1} !important; }
    [data-app-shell] { background-color: ${bg} !important; }
    [data-cresc-sidebar] { background-color: ${s1} !important; border-right-color: ${b2} !important; }

    .bg-\\[\\#0E0E10\\],.bg-\\[\\#0F1020\\],.bg-\\[\\#0A0A0A\\],.bg-\\[\\#090909\\],.bg-\\[\\#080808\\],.bg-\\[\\#0c0c0c\\],.bg-\\[\\#0C0C0C\\] { background-color: ${bg} !important; }
    .bg-\\[\\#111\\],.bg-\\[\\#111111\\],.bg-\\[\\#16172A\\] { background-color: ${s1} !important; }
    .bg-\\[\\#141414\\],.bg-\\[\\#141416\\],.bg-\\[\\#1E2040\\] { background-color: ${s2} !important; }
    .bg-\\[\\#1A1A1A\\],.bg-\\[\\#1a1a1a\\],.bg-\\[\\#161616\\],.bg-\\[\\#252748\\] { background-color: ${s3} !important; }
    .bg-\\[\\#0F0F0F\\],.bg-\\[\\#151515\\] { background-color: ${s1} !important; }

    .border-\\[\\#2A2A2A\\],.border-\\[\\#2a2a2a\\],.border-\\[\\#2E3060\\],.border-\\[\\#2A2A2E\\] { border-color: ${b1} !important; }
    .border-\\[\\#1A1A1A\\],.border-\\[\\#1a1a1a\\],.border-\\[\\#1E1E1E\\],.border-\\[\\#1E2040\\] { border-color: ${b2} !important; }

    .text-\\[\\#EDEDED\\],.text-\\[\\#F0F0F0\\],.text-\\[\\#FFFFFF\\] { color: ${t1} !important; }
    .text-\\[\\#A1A1AA\\],.text-\\[\\#8B8FA8\\] { color: ${t2} !important; }
    .text-\\[\\#71717A\\],.text-\\[\\#5A5D78\\],.text-\\[\\#56565E\\] { color: ${t3} !important; }
    .text-\\[\\#52525B\\],.text-\\[\\#3A3A3A\\],.text-\\[\\#3A3D55\\] { color: ${t4} !important; }

    .hover\\:bg-\\[\\#151515\\]:hover,.hover\\:bg-\\[\\#0F0F0F\\]:hover { background-color: ${s2} !important; }
    .hover\\:bg-\\[\\#1a1a1a\\]:hover,.hover\\:bg-\\[\\#1A1A1A\\]:hover { background-color: ${s3} !important; }
    .hover\\:text-\\[\\#EDEDED\\]:hover { color: ${t1} !important; }
  `;
}

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(() => {
    try { return localStorage.getItem("crescendo:theme") || "nebula"; } catch { return "nebula"; }
  });

  const theme = THEMES[themeId] || THEMES.nebula;

  useEffect(() => {
    const root = document.documentElement;
    Object.entries(theme.vars).forEach(([k, v]) => root.style.setProperty(k, v));
    let el = document.getElementById("crescendo-theme-overrides");
    if (!el) { el = document.createElement("style"); el.id = "crescendo-theme-overrides"; document.head.appendChild(el); }
    el.textContent = buildThemeCSS(theme.vars);
    try { localStorage.setItem("crescendo:theme", themeId); } catch {}
  }, [themeId, theme]);

  const setTheme = (id) => { if (THEMES[id]) setThemeId(id); };
  return <ThemeContext.Provider value={{ themeId, theme, setTheme, themes: THEMES }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
